import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const CreateOrgWithGradProgramPageContainerLoadable = clientOnlyLazy({
  loader: () => import('./CreateOrgWithGradProgramPageContainer'),
  loading: LoadableLoadingSection,
});
